import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'park',
  size: 24,
  node: [
    ['path', { d: 'M12 18h10', key: '1c50yy' }],
    [
      'path',
      {
        d: 'M13.248 9.998A4.5 4.5 0 0 0 11.75 8.6V8a1 1 0 0 0-7.5 0 4.9 4.9 0 0 0 2.25 9H8',
        key: 't0a46z',
      },
    ],
    ['path', { d: 'm15 14-2 6', key: 'u1moqn' }],
    ['path', { d: 'm19 14 2 6', key: 'ceqmri' }],
    ['path', { d: 'M21 14h-8', key: 'jf2tjg' }],
    ['path', { d: 'M8 20v-5.922a2 2 0 0 0-.586-1.414L6.5 11.75', key: '4fcolv' }],
    ['path', { d: 'M9.205 12.795 8 14', key: 'z0drss' }],
    ['circle', { cx: '19', cy: '6', r: '2', key: '1yudst' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name Park
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMThoMTAiIC8+CiAgPHBhdGggZD0iTTEzLjI0OCA5Ljk5OEE0LjUgNC41IDAgMCAwIDExLjc1IDguNlY4YTEgMSAwIDAgMC03LjUgMCA0LjkgNC45IDAgMCAwIDIuMjUgOUg4IiAvPgogIDxwYXRoIGQ9Im0xNSAxNC0yIDYiIC8+CiAgPHBhdGggZD0ibTE5IDE0IDIgNiIgLz4KICA8cGF0aCBkPSJNMjEgMTRoLTgiIC8+CiAgPHBhdGggZD0iTTggMjB2LTUuOTIyYTIgMiAwIDAgMC0uNTg2LTEuNDE0TDYuNSAxMS43NSIgLz4KICA8cGF0aCBkPSJNOS4yMDUgMTIuNzk1IDggMTQiIC8+CiAgPGNpcmNsZSBjeD0iMTkiIGN5PSI2IiByPSIyIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/park
 * @see https://lucide.dev/guide/packages/lucide-preact - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Park = createLucideIcon(__iconData);

export default Park;
